import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from "primeng/api";
import { ZorroTableComponent } from "../../../../components/common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../../../components/common/loading/loading.component";
import { DeleteConfirmationComponent } from "../../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { EditorItemModalComponent } from "../../../../components/modal-templates/generic-modal/editor-item-modal.component";
import { TcoFileUploadModalComponent } from "../../../../components/modal-templates/tco-file-upload-modal/tco-file-upload-modal.component";
import { SharedComponents } from "../../../../components/shared.module";
import { ConfigService } from "../../../../core/services/config/config.service";
import { RestTcoService } from "../../../../core/services/rest-tco.service";
import { TcoProjectService } from "../../../../core/services/tco-project/tco-project.service";
import { ToasterService } from "../../../../core/services/toaster-service";
import { UtilitiesService } from "../../../../core/services/utilities.service";
import { MaterialModule } from "../../../../core/shared/material.module";
import { ATTRIBUTE_OPTIONS, preProcessingMetaDataColumns } from "../../../../core/table-templates/pre-processing-meta-data-table";
import { preProcessingDataColumns } from "../../../../core/table-templates/pre-processing-table";
import { MessageEnum } from "../../../../core/utils/message.enum";

/**
 * Component for managing pre-processing data including versioning and recent records.
 * This component allows users to select versions and view recent records with an option to submit.
 */
const DEFAULT_METADATA_FIELDS = [
  {
    featureName: "Testcase name",
    width: "10",
    type: "varChar",
    requireForModel: "Yes",
    selected: false,
  },
  {
    featureName: "Testcase Description",
    width: "20",
    type: "varChar",
    requireForModel: "No",
    selected: true,
  },
  {
    featureName: "Test Step Description",
    width: "20",
    type: "varChar",
    requireForModel: "Yes",
    selected: true,
  },
  {
    featureName: "Expected Results",
    width: "20",
    type: "varChar",
    requireForModel: "Yes",
    selected: true,
  }
];
@Component({
  selector: "app-pre-processing",
  standalone: true,
  imports: [
    CommonModule,
    ZorroTableComponent,
    LoadingComponent,
    ...SharedComponents,
    MaterialModule,
  ],
  templateUrl: "./pre-processing.component.html",
  styleUrl: "./pre-processing.component.scss",
})
export class PreProcessingComponent implements OnInit {
  sectionData: any;
  recentRecords: any = {
    columns: preProcessingDataColumns,
  };
  isLoading = false;
  versioning: any = {
    data: null,
    options: {
      button: {
        text: "Submit",
      },
    },
  };
  category = "File History";
  userDetails: any;
  private modalService = inject(NgbModal);
  isUploading: boolean = false;
  formData: any;
  private messageService = inject(MessageService);
  selectedRows: any;
  tableData: any[] = [];
  isFirstTimeVisit = true;
  previousSelectedRow: any;
  extractedRealm: any;
  isProcessing: boolean = false;
  isDisabled = true;
  isFileRemoveDisabled = true;
  executionReleases: any = [];
  selectedFileData: any;
  testcasesFromReleaseIds: any = [];

  /**
   * Emits an event to move to the next tab.
   * @type {EventEmitter<void>}
   */
  @Output() moveToNextTabEvent = new EventEmitter<void>();

  /**
   * Creates an instance of PreProcessingComponent.
   * @param data The data passed from a parent component or service, injected via "STEP_DATA".
   */
  constructor(
    private restTcoService: RestTcoService,
    private configService: ConfigService,
    private utilityService: UtilitiesService,
    private tcoProjectService: TcoProjectService,
    private readonly toaster: ToasterService
  ) {
    this.extractedRealm = this.configService.getConfig("isDomainResolver")
      ? this.utilityService?.extractRealmFromUrl()
      : sessionStorage.getItem("selectedRealm");
  }

  /**
   * Lifecycle hook that is called when the component is initialized.
   * It triggers loading of versioning information and recent records.
   */
  ngOnInit() {
    this.loadPreProcessRecords();
  }

  /**
   * Loads recent pre-processing records into the `recentRecords` object.
   * The records include columns and rows of test data.
   */
  loadPreProcessRecords() {
    this.isLoading = true;
    this.loadExecutionReleases();
    this.restTcoService.getPreProcessRecords().subscribe(
      (item) => {
        this.isLoading = false;
        let index = 1;
        item?.data.forEach((element: any) => {
          element.size = this.utilityService.convertFileSize(element?.size);
          element.date = new Date(element?.date).toDateString();
          element.serial_number = index++;
          element.release = this.executionReleases;
        });
        // this.recentRecords["rows"] = item?.data;
        this.recentRecords["rows"] = item?.data
        .reverse()
        .map((item: any, index: number) => ({
          ...item,
          serial_number: index + 1,
        }));

        // console.log("table data", this.recentRecords?.rows);
        console.log("table data", JSON.stringify(this.recentRecords, null, 2));
        this.checkNextButtonState();
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  loadExecutionReleases(): void {
    this.restTcoService.getExecutionReleaseOptions(this.extractedRealm).subscribe((data) => {
      const executionResponse = data;
      const executionReleaseColumn = this.recentRecords.columns.find(
        (column: any) => column.key === 'release'
      );
  
      if (executionReleaseColumn) {
        // executionReleaseColumn._config.options = executionResponse;
        executionReleaseColumn._config.options = executionResponse.map((release: any) => ({
          label: release.releaseName,
          value: release.releaseId,
        }));
      }
      this.executionReleases = executionReleaseColumn._config.options;
      console.log("Execution Release ", executionReleaseColumn._config.options)
    });
  }

  
  addFile() {
    const fileUploadConfig = {
      fileUploadLabel: "Upload File or Directory",
      fileTypes: ".csv",
      buttonLabel: "Choose file",
      placeholderText: "Only .XLS & .CSV files, Max 25MB",
    };
    const modalRef = this.modalService.open(TcoFileUploadModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = {
      title: "Upload File or Directory",
      file: fileUploadConfig,
      //projectId: this.dataStore?.data?.id,
    };

    modalRef.result.then((result: any) => {
      const fileNameList = this.recentRecords.rows.map(
        (row: any) => row.filename
      );
      const isFileNamePresent = fileNameList.includes(
        result?.value?.file?.name
      );
      if (isFileNamePresent) {
        this.toaster.pop({ type: 'error', text: MessageEnum.FILE_UPLOAD_SAME_NAME_FAILURE });
      } else {
        this.isUploading = true;
        console.log("selectedRelease", result.value);

        const formData = new FormData();
        formData.append("id", result?.value?.file?.id);
        formData.append("file", result?.value?.file);
        formData.append("type", result?.value?.file?.type);
        formData.append("size", result?.value?.file?.size);
        formData.append("filename", result?.value?.file?.name);
        // formData.append("date", result?.value?.file?.lastModifiedDate);
        const uploadedDate = new Date().toString(); 
        formData.append("date", uploadedDate);
        formData.append("executionStatus", "false");

        this.restTcoService.uploadReportFile(formData).subscribe({
          next: (response) => {
            this.toaster.pop({ type: 'success', text: MessageEnum.FILE_UPLOAD_SUCCESS });
            this.isUploading = false;
            //resync data
            this.loadPreProcessRecords();            
          },
          error: (error) => {
            this.toaster.pop({ type: 'error', text: MessageEnum.FILE_UPLOAD_FAILURE });
            this.isUploading = false;
          },
        });
      }
    });
  }

  removeSelectedFiles() {
    this.selectedRows.forEach((element: any) => {
      this.restTcoService.deleteFiles(element?.id).subscribe(
        (response) => {
          this.toaster.pop({ type: 'success', text: MessageEnum.FILE_DELETE_SUCCESS });
          // Remove the deleted item from recentRecords.rows
          this.recentRecords.rows = this.recentRecords.rows.filter(
            (item: any) => item.id !== element.id
          );
        },
        (error) => {
          this.toaster.pop({ type: 'error', text: MessageEnum.FILE_DELETE_FAILURE });
        }
      );
    });
  }

  handleRowSelection(event: any) {
    this.selectedRows = event.data;
    this.tcoProjectService.setSelectedFile(this.selectedRows[0]);
    if (this.selectedRows !== this.previousSelectedRow) {
      this.previousSelectedRow = this.selectedRows;
      this.isFirstTimeVisit = true;
    }

    this.isFileRemoveDisabled = this.selectedRows?.length === 0;
    if (this.selectedRows?.length === 1) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
    this.checkNextButtonState();
  }

  processData() {
    console.log(this.selectedRows);
  
    this.tcoProjectService.getSelectedFile().subscribe((fileData) => {
      this.selectedFileData = fileData;
      console.log('Selected File Data:',  JSON.stringify(this.selectedFileData, null, 2));
    });
      const selectedReleases = this.selectedFileData?.selectedReleaseIds;
      if (
        this.selectedFileData && this.selectedFileData.selectedReleaseIds &&
        this.selectedFileData.selectedReleaseIds.length > 0
      ) {
        this.restTcoService.getTestCasesByMultipleReleaseIds(this.extractedRealm, selectedReleases)
          .subscribe({
            next: (response) => {
              this.testcasesFromReleaseIds = response;
              console.log("this.testcasesFromReleaseIds", this.testcasesFromReleaseIds);
              this.proceedAfterTestCasesLoaded();
            },
            error: (error) => {
              console.error('Error fetching test cases:', error);
              this.isProcessing = false;
            }
          });
      } else {
        this.proceedAfterTestCasesLoaded();
      }
  }
  proceedAfterTestCasesLoaded() {
    if (this.selectedRows?.length === 1 && this.category === "File History") {
      this.isProcessing = true;
      this.restTcoService
        .downloadFileContent(this.selectedFileData?.id)
        .subscribe(
          (response: Blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              const fileContent = reader.result as string;
              // Now you have the file content, send it to the Python backend
              this.sendFileContentToPython(fileContent, this.selectedRows[0]);
            };
            reader.readAsText(response);
          },
          (error) => {
            this.isProcessing = false;
          }
        );
    } else if (this.category === "Metadata Catalogue") {
      this.isProcessing = true;
      this.restTcoService
        .prosessFileStep2({ tenantId: this.extractedRealm })
        .subscribe(
          (item) => {
            this.isProcessing = false;
            this.moveToNextTabEvent.emit();
          },
          (error) => {
            this.isProcessing = false;
            this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_CATALOGUE_FAILURE });
          }
        );
    }
  }
  sendFileContentToPython(fileContent: string, selectedFile: any): void {
    let requestPayload: any = {};
    if (
      this.selectedFileData && this.selectedFileData.selectedReleaseIds &&
      this.selectedFileData.selectedReleaseIds.length > 0
    ){
      requestPayload = {
        releaseIdsTestcases: this.testcasesFromReleaseIds,
        fileId: selectedFile.id,
        recentFileName: selectedFile.filename,
        tenantId: this.extractedRealm,
      };
    }
    else{
      const utf8EncodedContent = btoa(unescape(encodeURIComponent(fileContent)));
        requestPayload = {
        fileData: utf8EncodedContent,
        fileId: selectedFile.id,
        recentFileName: selectedFile.filename,
        tenantId: this.extractedRealm,
      };
    }
    console.log("PY Data", requestPayload);
    this.restTcoService
      .processFileContent(requestPayload)
      .subscribe((response) => {
        console.log("PY res[onse", response);
        if (response.data === "METADATA GENERATED") {
          if (response.execution_status === true) {
          if(response.is_releasewise_below_threshold){
            const releasesBelowThreshold = response.stable_testcases_summary
            ?.filter((release: any) => release.is_below_threshold)
            .map((release: any) => release.releaseName);
            const labelText = releasesBelowThreshold.join(', ');
            const warningMessage = `Optimization skipped: The Number of Stable Test Cases is Below the Required Threshold (≤10) in the Following Release(s): ${labelText}`;
            this.toaster.pop({ type: 'error', text: warningMessage });
            this.isProcessing = false;
            return;
            }
            else{
            this.restTcoService
              .updateExecutionStatus(selectedFile.id, response.execution_status)
              .subscribe((resp: any) => {
                this.isProcessing = false;
                console.log(
                  "Response After Update Execution Status in File:",
                  resp
                );
                this.toaster.pop({ type: 'success', text: MessageEnum.METADATA_GENERATE_SUCCESS });
                this.getMetaDataEntries();
              });
            }
          } else {
            this.isProcessing = false;
            this.toaster.pop({ type: 'success', text: MessageEnum.METADATA_GENERATE_SUCCESS });
            this.getMetaDataEntries();
          }
        } else {
          this.isProcessing = false;
          this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_GENERATE_FAILURE });
        }
      });
  }

  getMetaDataEntries() {
    this.restTcoService.getAllMetadataEntries().subscribe(
      (response) => {
        console.log("metaData", response);
        if (!response || response.length === 0) {
          this.tableData = [...DEFAULT_METADATA_FIELDS];
          this.restTcoService.updateMetadataEntries(this.tableData).subscribe(
            (res) => {
              this.toaster.pop({ type: 'success', text: MessageEnum.METADATA_INITIALIZED });
            },
            (err) => {
              this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_INITIALIZED_FAILED });
            }
          );
        } else {
          this.tableData = response;
        } 
        if (this.selectedRows?.length && !this.selectedRows[0]?.executionStatus) {
          this.tableData = this.tableData.filter(
            (entry: any) => entry.featureName !== "Execution Status"
          );
        }
  
        this.initializeFirstTwoEntriesToBack(); 
        this.recentRecords.columns = preProcessingMetaDataColumns;
        let index = 1;
        this.tableData.forEach((item: any) => {
          item.serial_number = index++;
        });
        this.recentRecords["rows"] = this.tableData;
        this.category = "Metadata Catalogue";
      },
      (error) => {
        console.error(error);
        this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_GENERATE_FAILURE });
      }
    );
  }

  initializeFirstTwoEntriesToBack() {
    if (this.isFirstTimeVisit) {
      this.tableData.forEach((item) => {
        if (item.featureName === 'Testcase Name') {
          item.requireForModel = 'Yes';
        } else if (item.featureName === 'Testcase Description') {
          item.requireForModel = 'No';
        }
      });
      this.isFirstTimeVisit = false;
    }
  }
  handleRequireForModelChange(event: { index: number, value: string }): void {
    
    const testcaseNameRow = this.tableData.find(row => row.featureName === 'Testcase Name');
    const testcaseDescRow = this.tableData.find(row => row.featureName === 'Testcase Description');
  
    if (testcaseNameRow && testcaseDescRow) {
      if (testcaseNameRow.requireForModel === "Yes") {
        testcaseDescRow.requireForModel = "No";
      } else if (testcaseDescRow.requireForModel === "Yes") {
        testcaseNameRow.requireForModel = "No";
      }
    }
  }
  
  addNewField() {
    this.openGenericModal();
  }

  removeSelectedFields() {
    this.selectedRows.forEach((element: any) => {
      this.restTcoService.deleteMetaDataField(element?.id).subscribe(
        (response) => {
          this.toaster.pop({ type: 'success', text: MessageEnum.METADATA_DELETE_SUCCESS });
          // Remove the deleted item from recentRecords.rows
          this.recentRecords.rows = this.recentRecords.rows.filter(
            (item: any) => item.id !== element.id
          );
        },
        (error) => {
          console.error("Error saving form data:", error);
          this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_DELETE_FAILURE });
        }
      );
    });
  }

  openGenericModal() {
    var modalParams: any = {
      title: "Add New Field",
    };
  
    var fields: any = [
      {
        type: "select",
        name: "Attribute",
        key: "featureName",
        id: "featureName",
        options:ATTRIBUTE_OPTIONS,
      },
      {
        type: "text-input",
        name: "Width (Characters)",
        key: "width",
        id: "width",
      },
      {
        type: "select",
        name: "Type",
        key: "type",
        id: "type",
        options: [
          {
            label: "varChar",
            value: "varChar",
          },
          {
            label: "int",
            value: "int",
          },
        ],
      },
      {
        key: "requireForModel",
        id: "requireForModel",
        name: "Require for Model Build",
        type: "radio",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        customClass: "col-md-6",
        value: "model_build",
      },
    ];
  
    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = modalParams;
    modalRef.componentInstance.fields = fields;
  
    modalRef.result.then((result) => {
      console.log("result", result);
      // Normalize the entered featureName to lowercase and remove spaces for comparison
      const normalizeFeatureName = (name: string) => {
        return name.trim().toLowerCase().replace(/\s+/g, '');
      };
  
      const newFeatureNameNormalized = normalizeFeatureName(result.value.featureName);
  
      // Check if the featureName already exists in the recentRecords.rows
      const isDuplicate = this.recentRecords.rows.some((row: any) => {
        return normalizeFeatureName(row.featureName) === newFeatureNameNormalized;
      });
      if (isDuplicate) {
        this.toaster.pop({ type: 'error', text: MessageEnum.METADATA_EXIST });
    } 
    else {
        // Add the new field if no duplicates are found
        this.recentRecords.rows.push(result.value);
        
        this.restTcoService.updateMetadataEntries(this.recentRecords.rows).subscribe(
          (response) => {
            this.toaster.pop({ type: 'success', text: MessageEnum.METADATA_GENERATE_SUCCESS });
            this.getMetaDataEntries();
          },
          (error) => {
            console.error("Error saving form data:", error);
          }
        );
      }
    });
  }
  checkNextButtonState(): void {
    const hasRows = this.recentRecords?.rows?.length > 0;
    if (this.category === "Metadata Catalogue") {
      this.isDisabled = !hasRows;
    } else {
      const hasOneSelected = this.selectedRows?.length === 1;
      this.isDisabled = !(hasRows && hasOneSelected);
    }
  }

  handleActions(params: any) {
    if (params?.type === "multi-select") {

      const selectedReleases = (params.data.row.release || [])
        .filter((item: any) => typeof item === 'string');
  
      // Get the row ID to find the correct row in recentRecords
      const rowId = params.data.row.id;
  
      // Find and update the matching row
      const targetRow = this.recentRecords.rows.find((row: any) => row.id === rowId);
  
      if (targetRow) {
        targetRow.selectedReleaseIds = selectedReleases;
        console.log('Updated row with selectedReleaseIds:', targetRow);
      }
    }
    if (params?.type === 'select') {
      const updatedRows = [...this.recentRecords.rows];
  
      const currentIndex = updatedRows.findIndex(
        row => row.id === params.data.row.id
      );
        this.recentRecords = {
            ...this.recentRecords,
            rows: updatedRows
          };
    }
  }
  
  openDeleteConfirmation() {
    const modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      size:"sm",
      centered: true,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      title: 'Confirm Deletion',
      description: 'Are you sure you want to delete the selected file?',
    };

    modalRef.result
      .then((confirmed) => {
        if (confirmed) {
          this.removeSelectedFiles();
        }
      })
      .catch(() => {
      });
  }
  
}
